<template>
  <div class="playlist-group-demo">
    <div class="playlist-group-demo__header">
      <back-btn :canReturn="canReturn" :backRoute="{ name: 'demo' }" :shouldPop="shouldPop" dark />
      <demo-badge />
    </div>
    <playlist-group :demo="true" :playlistGroupId="playlistGroupId" @demoActivated="$emit('demoActivated')" />
  </div>
</template>

<script>
export default {
  name: 'playlist-group-demo',
  props: {
    canReturn: Boolean,
    shouldPop: Boolean,
    playlistGroupId: String
  },
  computed: {
    playlistGroup() {
      const playlistGroup = this.$store.getters['contentTree/findPlaylistGroup'](this.playlistGroupId)
      if (!playlistGroup) {
        this.$router.replace({ name: 'demo' })
      }

      return playlistGroup
    }
  },
  metaInfo() {
    return {
      title: `PlayKids | ${this.playlistGroup.title}`,
      script: [
        {
          innerHTML: `{
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "PlayKids",
              "item": "https://app.playkids.com"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Demo",
              "item": "https://app.playkids.com/demo"
            },{
              "@type": "ListItem",
              "position": 3,
              "name": "${this.playlistGroup.title}",
              "item": "https://app.playkids.com/demo/${this.playlistGroupId}"
            }]
          }`,
          type: 'application/ld+json'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.playlist-group-demo {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > .demo-badge {
      margin-right: 24px;
    }
  }
}
</style>
